module.exports = "https://static.energy5.com/_next/static/images/all-logos-dfd5aa89b432b98cd357a7dcbd149e8b.png";